import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.profesiones;

const profesionService = {
  // Obtener todas las profesiones
  async getAllProfesiones() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/profesion`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener profesiones:', error);
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Obtener profesión por ID
  async getProfesionById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/profesion/id/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener profesión:', error);
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Buscar profesión por nombre
  async getProfesionByNombre(nombre) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/profesion/nombre/${nombre}`);
      return response.data;
    } catch (error) {
      console.error('Error al buscar profesión:', error);
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Crear nueva profesión
  async createProfesion(profesionData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/profesion/crear`, {
        PROFESION_NOMBRE: profesionData.PROFESION_NOMBRE,
        PROFESION_OBSERVACION: profesionData.PROFESION_OBSERVACION
      });
      
      return response.data;
    } catch (error) {
      console.error('Error al crear profesión:', error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Actualizar profesión
  async updateProfesion(id, profesionData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/profesion/actualizar/${id}`, {
        PROFESION_NOMBRE: profesionData.PROFESION_NOMBRE,
        PROFESION_OBSERVACION: profesionData.PROFESION_OBSERVACION
      });
      
      return response.data;
    } catch (error) {
      console.error('Error al actualizar profesión:', error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Desactivar profesión (cambiar estado a inactivo)
  async deleteProfesion(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/api/profesion/eliminar/${id}`);
      
      return response.data;
    } catch (error) {
      console.error('Error al desactivar profesión:', error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Activar profesión (cambiar estado a activo)
  async activateProfesion(id) {
    try {
      const response = await axios.patch(`${API_BASE_URL}/api/profesion/activar/${id}`);
      
      return response.data;
    } catch (error) {
      console.error('Error al activar profesión:', error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Obtener profesiones ordenadas ascendente
  async getProfesionesAsc() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/profesion/orden/asc`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener profesiones ordenadas:', error);
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  },

  // Obtener profesiones ordenadas descendente
  async getProfesionesDesc() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/profesion/orden/desc`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener profesiones ordenadas:', error);
      throw new Error(`Error HTTP: ${error.response?.status || 'Desconocido'}`);
    }
  }
};

export default profesionService;